import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Form,
  FormGroup,
  FormField,
  Button,
  Input
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardPatientRecordInterfaceUX = (props: any) => {
    return(
      <div
        id="CardPatientRecordInterfaceUX-div-0"
        style={{width: "calc(-150px + 100vw)", height:"100%",padding:"10px"}}>
        <div
          id="CardPatientRecordInterfaceUX-div-1"
          style={{padding: "10px 5px 15px", marginBottom: "-10px"}}>
          
          <Form
            id="CardPatientRecordInterfaceUX-Form-9">
            <FormGroup
              id="CardPatientRecordInterfaceUX-FormGroup-10"
              style={{ marginBottom: "0px"}}>
              <FormField
                id="CardPatientRecordInterfaceUX-FormField-16"
                width={2}>
                <label
                  id="CardPatientRecordInterfaceUX-label-23">
                  วันที่สร้าง
                </label>
              </FormField>
              <FormField
                id="CardPatientRecordInterfaceUX-FormField-17"
                width={2}>
                <label
                  id="CardPatientRecordInterfaceUX-label-21">
                  HN
                </label>
              </FormField>
              <FormField
                id="CardPatientRecordInterfaceUX-FormField-18"
                width={2}>
                <label
                  id="CardPatientRecordInterfaceUX-label-22">
                  Full Name
                </label>
              </FormField>
              <FormField
                id="CardPatientRecordInterfaceUX-FormField-19"
                width={2}>
                <label
                  id="CardPatientRecordInterfaceUX-label-20">
                  {"\u00A0"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardPatientRecordInterfaceUX-FormGroup-11">
              <FormField
                id="CardPatientRecordInterfaceUX-FormField-12"
                width={2}>
                <div
                  id="CardPatientRecordInterfaceUX-div-27"
                  style={{ width: "100%" }}>
                  
                  <DateTextBox
                    id="CardPatientRecordInterfaceUX-DateTextBox-32"
                    onChange={props.onChangeDate}
                    value={props.searchPatientRecord?.createDate}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardPatientRecordInterfaceUX-FormField-13"
                width={2}>
                <div
                  id="CardPatientRecordInterfaceUX-div-26"
                  style={{ width: "100%" }}>
                  
                  <Input
                    id="CardPatientRecordInterfaceUX-Input-34"
                    name="hn"
                    onChange={props.onChangeData}
                    value={props.searchPatientRecord?.hn || ""}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardPatientRecordInterfaceUX-FormField-14"
                width={2}>
                <div
                  id="CardPatientRecordInterfaceUX-div-25"
                  style={{ width: "100%" }}>
                  
                  <Input
                    id="CardPatientRecordInterfaceUX-Input-33"
                    name="fullName"
                    onChange={props.onChangeData}
                    value={props.searchPatientRecord?.fullName || ""}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardPatientRecordInterfaceUX-FormField-15"
                width={2}>
                <div
                  id="CardPatientRecordInterfaceUX-div-24"
                  style={{ width: "100%", display: "flex" }}>
                  
                  <div
                    id="CardPatientRecordInterfaceUX-div-28"
                    style={{ margin: "0px 20px" }}>
                    
                    <div
                      id="CardPatientRecordInterfaceUX-div-30">
                      {props.buttonSeach}
                    </div>
                  </div>
                  <div
                    id="CardPatientRecordInterfaceUX-div-29">
                    
                    <Button
                      color="orange"
                      id="CardPatientRecordInterfaceUX-Button-31"
                      onClick={props.onClickClear}>
                      Clear
                    </Button>
                  </div>
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardPatientRecordInterfaceUX-div-2">
          
          <Table
            className="--rt-tbody-overflow-y-hidden"
            columns={props.patientRecordColumns}
            data={props.patientRecordData}
            id="CardPatientRecordInterfaceUX-Table-8"
            minRows={5}
            onPageChange={props.onPageChange}
            onPageSizeChange={props.onPageSizeChange}
            page={props.paginatedItems?.page || 0}
            pageSize={props.paginatedItems?.pageSize || 0}
            pages={Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)}
            style={{ height: "calc(95vh - 14.5rem)"}}>
          </Table>
        </div>
        <div
          id="CardPatientRecordInterfaceUX-div-3"
          style={{ display: "flex", justifyContent: "flex-end", margin: "20px 0px" }}>
          
          <div
            id="CardPatientRecordInterfaceUX-div-4">
            
            <div
              id="CardPatientRecordInterfaceUX-div-7">
              {props.buttonAdd}
            </div>
          </div>
          <div
            id="CardPatientRecordInterfaceUX-div-5"
            style={{ margin: "0px 20px" }}>
            
            <div
              id="CardPatientRecordInterfaceUX-div-6">
              {props.buttonEdit}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardPatientRecordInterfaceUX

export const screenPropsDefault = {}

/* Date Time : Mon Apr 28 2025 09:09:17 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"calc(-150px + 100vw)\", height:\"100%\",padding:\"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 5px 15px\", marginBottom: \"-10px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-div-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\", margin: \"20px 0px\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-div-4"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 20px\" }"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonEdit"
        },
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-div-6"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonAdd"
        },
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-div-7"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 8,
      "name": "Table",
      "parent": 2,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "code",
          "value": "props.patientRecordColumns"
        },
        "data": {
          "type": "code",
          "value": "props.patientRecordData"
        },
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-Table-8"
        },
        "minRows": {
          "type": "code",
          "value": "5"
        },
        "onPageChange": {
          "type": "code",
          "value": "props.onPageChange"
        },
        "onPageSizeChange": {
          "type": "code",
          "value": "props.onPageSizeChange"
        },
        "page": {
          "type": "code",
          "value": "props.paginatedItems?.page || 0"
        },
        "pageSize": {
          "type": "code",
          "value": "props.paginatedItems?.pageSize || 0"
        },
        "pages": {
          "type": "code",
          "value": "Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"calc(95vh - 14.5rem)\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "Form",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-Form-9"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormGroup",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-FormGroup-10"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"0px\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormGroup",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-FormGroup-11"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-FormField-12"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-FormField-13"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-FormField-14"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-FormField-15"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-FormField-16"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-FormField-17"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-FormField-18"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-FormField-19"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "label",
      "parent": 19,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-label-20"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "label",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "HN"
        },
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-label-21"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "label",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "Full Name"
        },
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-label-22"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "label",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่สร้าง"
        },
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-label-23"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-div-24"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\" }"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-div-25"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-div-27"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 24,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 20px\" }"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 24,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-div-29"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSeach"
        },
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-div-30"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "Button",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": "Clear"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-Button-31"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickClear"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 32,
      "name": "DateTextBox",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-DateTextBox-32"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate"
        },
        "value": {
          "type": "code",
          "value": "props.searchPatientRecord?.createDate"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "Input",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-Input-33"
        },
        "name": {
          "type": "value",
          "value": "fullName"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchPatientRecord?.fullName || \"\""
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "Input",
      "parent": 26,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientRecordInterfaceUX-Input-34"
        },
        "name": {
          "type": "value",
          "value": "hn"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchPatientRecord?.hn || \"\""
        }
      },
      "seq": 34,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardPatientRecordInterfaceUX",
  "project": "CLM CU",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
